
import React from "react";
import "./OracleIdentityManagement.css";
import MenuNavbar from "../../MenuNavbar";
import Floaticons from "../../Floaticons";
import Tabs from "@mui/material/Tabs";
import PropTypes from "prop-types";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import IdentiyAccessManagement from "../IdentityManagement/IdentityandAccessManagement";
import InfrastructureSecurity from "../InfrastructureSecurity/InfrastructureSecurity";
import PlatformSecurity from "../PlatformSecurity/PlatformSecurity";
import CloudSecurity from "../CloudSecurity/CloudSecurity";
import Link from "@mui/material/Link";
import HomeIcon from "@mui/icons-material/Home";
import { Breadcrumbs } from "@material-ui/core";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 4 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

function OracleIdentiyManagement() {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <>
      <div className="banner-container">
        <img
          src="images/SecuritySchools/SailPoint/school-banner.png"
          alt="banner"
          className="banner-img"
        />
        <div className="breadcrumbs-container">
          <Breadcrumbs separator=">" color="#fff">
            <Link
              underline="hover"
              sx={{ display: "flex", alignItems: "center" }}
              color="#fff"
              href="/"
            >
              <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
            </Link>
            ,
            <Link
              underline="hover"
              key="2"
              color="#fff"
              href="/securityLearningFramework"
              // onClick={handleClick}
            >
              Security Learning Framework
            </Link>
            ,
            <Typography key="3" color="#fff">
              Security Schools
            </Typography>
            ,
          </Breadcrumbs>
        </div>
        <div className="banner-content">
          <h1>Security Schools</h1>
          <i>
            Lorem ipsum is a dummy text of the printing and typesetting industry
          </i>
        </div>
        <MenuNavbar />
      </div>
      <Floaticons />
      <div className="breadcrumbLinks">
        <Breadcrumbs separator=">" aria-label="breadcrumb">
          <a className="menu_title" href="/securitySchools">
            <img src="/images/SecuritySchools/Back-button.png" />
            Security Schools and Bootcamps​
          </a>
          {value === 0 ? (
            <a className="menu_title" href="/securitySchools#I&DInitiatives">
              Identity & Access Management
            </a>
          ) : (
            ""
          )}
          {value === 1 ? (
            <a className="menu_title" href="/securitySchools#InfrastructureSecurity">
              Infrastructure Security
            </a>
          ) : (
            ""
          )}
          {value === 2 ? (
            <a className="menu_title" href="/securitySchools#platformsecurity">
              Platform Security
            </a>
          ) : (
            ""
          )}
          {value === 3 ? (
            <a className="menu_title" href="/securitySchools#cloudsecurity">
              Cloud Security
            </a>
          ) : (
            ""
          )}
          <a className="menu_title" href="">
            Oracle Identity Management​
          </a>
        </Breadcrumbs>
      </div>
      <div className="main-container">
        <Box className="boxStyles">
          <Box
            sx={{ borderBottom: 0, borderColor: "divider" }}
            className="tabMenuWrap"
          >
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="basic tabs example"
              centered
            >
              <Tab
                label="Identity & Access Management​"
                {...a11yProps(0)}
                className="tabStyles"
              />
              <Tab
                label="Infrastructure Security"
                {...a11yProps(1)}
                className="tabStyles"
              />
              <Tab
                label="Platform Security"
                {...a11yProps(2)}
                className="tabStyles"
              />
              <Tab
                label="Cloud Security"
                {...a11yProps(3)}
                className="tabStyles"
                // href='https://atci.lkm.delivery.accenture.com/ProfessionalSkills/' target='_blank'
              />
            </Tabs>
          </Box>
          <TabPanel className="tabPanelWrap" value={value} index={0}>
            <div className="Oracle-AboutWrapp">
              <div className="leftImage">
                <img
                  src="images/SecuritySchools/OracleIdentity/About-Oracle-Identity-Management.png"
                  alt=""
                  className="img-responsive"
                />
              </div>
              <div className="rightContent">
                <h2 className="SP-AboutHeading">
                  About the Oracle Identity Management​
                </h2>
                <p>
                  With Accenture Security’s focus on Identity & Access
                  Management practice, it becomes important that we learn,
                  design, and implement IAM solutions based on client
                  requirements across a variety of vendor products.<br></br>
                  We have designed the{" "}
                  <strong>Oracle Identity Manager(OIM)</strong> training program
                  to hone the technical knowledge in the changing landscape of
                  Identity & Access Management. The modules in the curriculum
                  aim to equip with managing the entire user identity life cycle
                  across all enterprise resources with Oracle Identity
                  Manager(OIM).​​
                </p>
              </div>
            </div>
            <div className="keyObjective-wrapper" id="Oracle-Objective">
              <h2 className="key-obj-heading">Key Objectives:</h2>
              <div className="obj-inner-row">
                <div className="objectiveBox">
                  <img
                    src="images/SecuritySchools/OracleIdentity/Oracle-key-icon1.png"
                    alt="key-objectives-icon"
                  />
                  <p>
                    Cross-Skilling employees on OIM for smooth project delivery​
                  </p>
                </div>
                <div className="objectiveBox">
                  <img
                    src="images/SecuritySchools/OracleIdentity/Oracle-key-icon2.png"
                    alt="key-objectives-icon"
                  />
                  <p>
                    Create an OIM talent pool to gear up for the resourcing
                    requirement for the projects in the pipeline.​​
                  </p>
                </div>
                <div className="objectiveBox">
                  <img
                    src="images/SecuritySchools/OracleIdentity/Oracle-key-icon3.png"
                    alt="key-objectives-icon"
                  />
                  <p>Develop an in-house learning capability on OIM.​​</p>
                </div>
              </div>
              <div className="topics-Wrapp">
                <h2 className="topics-heading">Topics in focus</h2>
                <div className="topic-TopSection">
                  <div className="box-wrap">
                    <h3>Configuring OOTB connector</h3>
                    <ul>
                      <li>Deploying the OOTB connector</li>
                      <li>Configuring IT resource</li>
                      <li>Creating Application Instance and UI form</li>
                    </ul>
                  </div>
                  <div className="box-wrap">
                    <h3>Configuring Custom Connector</h3>
                    <ul>
                      <li>Creating IT resource</li>
                      <li>Creating and configuring Resource Objective</li>
                      <li>Creating and configuring Process Definition</li>
                      <li>Creating Process Form</li>
                      <li>Creating Application Instance and Ul form</li>
                    </ul>
                  </div>
                  <div className="box-wrap">
                    <h3>Creating and configuring adapters</h3>
                    <ul>
                      <li>Developing code for the adapter</li>
                      <li>Developing adapter code through upload utility</li>
                      <li>Configuring adapter in design console</li>
                      <li>
                        Attaching adapter to process tasks or process from
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="topic-Middle-image">
                  <img
                    src="images/SecuritySchools/OracleIdentity/Topics-arrow.png"
                    alt=""
                    className=""
                  />
                </div>
                <div className="topic-BottomSection">
                  <div className="box-wrap">
                    <h3>Creating and configuring schedulers</h3>
                    <ul>
                      <li>Developing the code</li>
                      <li>Deploying scheduler code though plugins</li>
                      <li>Configuring the scheduler In OIM</li>
                      <li>Creating roles, access policies</li>
                      <li>Creating approval policies</li>
                      <li>Cresting UDF</li>
                    </ul>
                  </div>
                  <div className="box-wrap">
                    <h3>Sandbox concept</h3>
                    <ul>
                      <li>Creating Sandbox</li>
                      <li>Publishing sandbox</li>
                    </ul>
                  </div>
                  <div className="box-wrap">
                    <h3>Ul changes</h3>
                    <ul>
                      <li>Creating sandbox</li>
                      <li>Adding buttons, text fields, and other components</li>
                      <li>
                        Hiding components, making the field as required, etc.
                      </li>
                      <li>Publishing sandbox</li>
                    </ul>
                  </div>
                </div>
                <div className="row1-bottom-section">
                  <div>
                    <p className="border-Heading">
                      <span>Total Duration: 100 hours across 4 weeks​</span>
                      <img
                        src="images/SecuritySchools/SecurityPlatforms/arrow.png"
                        alt=""
                      />
                    </p>
                    <p>
                      <span className="bold">Training model :</span> <br></br>
                      <span className="light">
                        VILT+ Hands-on + Assessments​
                      </span>
                      ​
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </TabPanel>
          <TabPanel className="tabPanelWrap" value={value} index={1}>
            <InfrastructureSecurity />
          </TabPanel>
          <TabPanel className="tabPanelWrap" value={value} index={2}>
            <PlatformSecurity />
          </TabPanel>
          <TabPanel className="tabPanelWrap" value={value} index={3}>
            <CloudSecurity />
          </TabPanel>
        </Box>
      </div>
    </>
  );
}

export default OracleIdentiyManagement;

